import { useQuery } from "@tanstack/react-query"
import { getProjectById } from "../../../api/projects/getProjectById"

export const useGetProjectById = (projectId: number) => {

  return useQuery({
    queryKey: ['projectById', projectId],
    queryFn: () => getProjectById(projectId),
    staleTime: 1000 * 60 * 60,
    retry: 1
  })
}
